// extracted by mini-css-extract-plugin
export var brand = "_br-9";
export var compact = "_br-6";
export var extraSmall = "_br-7";
export var icon = "_br-0";
export var large = "_br-4";
export var light = "_br-1";
export var medium = "_br-5";
export var outline = "_br-b";
export var primaryDark = "_br-a";
export var primaryLight = "_br-8";
export var primaryModern = "_br-c";
export var success = "_br-2";
export var successSolid = "_br-3";